import { render, staticRenderFns } from "./FormRadioGroup.vue?vue&type=template&id=8b46b6fa"
import script from "./FormRadioGroup.vue?vue&type=script&lang=js"
export * from "./FormRadioGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports